var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-nav"},[_c('static-banner',{attrs:{"image_banner":_vm.image_banner,"main-title":"企业公告"}}),_c('NewsContent',{attrs:{"news-type":"3","content-title":"企业公告"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }